const devServer = ['local.com:9292', '127.0.0.1:9292'].some((localUrl) =>
  window.location.href.includes(localUrl)
)

if (!devServer) {
  if (!crypto.randomUUID) {
    crypto.randomUUID = () => {
      return 'xxxxxxxx-xxxx-5xxx-txxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }

  // Add this to your existing JavaScript
  // Always refresh cart data on pageshow, regardless of persisted state
  // This ensures it works in all environments, including published themes
  window.addEventListener('pageshow', update)

  // Additionally, listen for the 'popstate' event which fires when navigating history
  window.addEventListener('popstate', function () {
    // Short timeout to ensure the page has fully transitioned
    setTimeout(() => update, 100)
  })

  async function update() {
    await cartRefresh()
    try {
      const response = await fetch(`/cart.json?v=${crypto.randomUUID()}`)
      const cart = await response.json()
      updateHeaderCartCount(cart.item_count)
      updateCartDrawer()
    } catch (error) {
      console.error('Error fetching cart:', error)
    }
  }

  //this is needed to ensure the discounts are applied after a user has just joined the newsletter
  //without this sometimes a cached cart is used which doesn't included newsletter subscribers only discounts
  async function cartRefresh() {
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({})
        }
      )

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error refreshing cart:', error)
    }
  }
}
